import * as React from 'react'
import clsx from 'clsx'

import styles from './Spinner.module.css'

export const Spinner = ({ className }: { className?: string }) => {
  return <div className={clsx(styles.spinner, className)} />
}
